module.exports = __webpack_public_path__ + "static/media/tini-convert.23f52dea.png";